export default __webpack_public_path__ + "static/media/commitment-icon.543fbcda.png";